export const DEFAULT_COLOR = { r: 0, g: 0, b: 0 };
export const DEFAULT_SIZE = 3;
export enum Color {
    RED = "RED", 
    GREEN = "GREEN", 
    BLUE = "BLUE"
}
